var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17157 1.17157C0 2.34315 0 4.22876 0 8C0 11.7712 0 13.6569 1.17157 14.8284C2.34315 16 4.22876 16 8 16H10C13.7712 16 15.6569 16 16.8284 14.8284C18 13.6569 18 11.7712 18 8C18 4.22876 18 2.34315 16.8284 1.17157C15.6569 0 13.7712 0 10 0H8C4.22876 0 2.34315 0 1.17157 1.17157ZM11.6742 4H6.36565V12H9.35784C9.99065 12 10.5362 11.8919 10.9946 11.6758C11.4555 11.4596 11.811 11.1602 12.061 10.7773C12.311 10.3919 12.436 9.94792 12.436 9.44531C12.436 8.9401 12.311 8.5013 12.061 8.12891C11.811 7.75651 11.4555 7.46875 10.9946 7.26562C10.5362 7.0599 9.99065 6.95703 9.35784 6.95703H8.05706V5.39453H11.6742V4ZM9.35784 10.6406H8.05706V8.29297H9.35784C9.81096 8.29297 10.1573 8.40365 10.3969 8.625C10.6391 8.84375 10.7602 9.11198 10.7602 9.42969C10.7602 9.64844 10.7055 9.85026 10.5961 10.0352C10.4893 10.2174 10.3318 10.3646 10.1235 10.4766C9.91513 10.5859 9.65992 10.6406 9.35784 10.6406Z",
    fill: "url(#paint0_linear_965_5138)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_965_5138",
    x1: 0,
    y1: 0,
    x2: 18,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01CD77"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBGreen);
export default __webpack_public_path__ + "static/media/b-green.b9ca34ed948348d5b2283bc8b693faea.svg";
export { ForwardRef as ReactComponent };